import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CountryCode } from '@/store/ui';
import { getCountryByHostname } from '@/helpers/country';
import { Routes } from '@/router';

@Component({
  name: 'CmgCreateAccountPage',
})
export default class CmgCreateAccountPage extends Vue {
  currentCountry = this.$appStore.state.ui.countryProfile.countryCode;
  showForm = true; // a flag to toggle animation when swapping country

  get modalImageSrc(): string {
    let src = '';
    if (this.currentCountry == CountryCode.US) {
      src = this.$appStore.state.cms.createAccountForm?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
    } else if (this.currentCountry == CountryCode.CA) {
      src = this.$appStore.state.cms.createAccountForm?.imageUrl || this.$appStore.state.cms.images.logos.medallion.default;
    }
    return src;
  }

  get countryCode(): string {
    return this.currentCountry;
  }

  get headingText() {
    return this.$router.currentRoute.name === Routes.VendorCreateAccount
      ? 'JOIN CHIPOTLE REWARDS'
      : (this.showVerifyMobileNumber ? 'VERIFY YOUR PHONE NUMBER' : this.$appStore.state.cms.createAccountForm?.heading ||'CREATE AN ACCOUNT');
  }

  get showVerifyMobileNumber(): boolean {
    return this.$appStore.state.ui.showVerifyMobileNumber;
  }

  created() {
    const countryProfile = getCountryByHostname(window.location.hostname);
    if (countryProfile) {
      this.$services.ui.setCountryProfile(countryProfile, false);
      this.currentCountry = this.$appStore.state.ui.countryProfile.countryCode;
    }
  }

  setCurrentCountry(country: string) {
    this.currentCountry = country;
    this.showForm = false;
    this.$nextTick(() => (this.showForm = true));
  }
}
